export const FONT_FAMILY = "Google Sans";

export const RIDE_NOW_TYPE = "1";
export const RIDE_LATER_TYPE = "2";

export const GOOGLE_API_KEY = "AIzaSyAZPSzX92Qd6rqqtZwKGOxcs515YDeuMQk";
